import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import s, { useState as c } from "react";
import { useIsMounted as m } from '../hooks/use-is-mounted.js';
import { Hidden as f, HiddenFeatures as l } from './hidden.js';
function b(_ref) {
  var n = _ref.onFocus;
  var _c = c(!0),
    _c2 = _slicedToArray(_c, 2),
    r = _c2[0],
    o = _c2[1],
    u = m();
  return r ? s.createElement(f, {
    as: "button",
    type: "button",
    features: l.Focusable,
    onFocus: function onFocus(a) {
      a.preventDefault();
      var e,
        i = 50;
      function t() {
        if (i-- <= 0) {
          e && cancelAnimationFrame(e);
          return;
        }
        if (n()) {
          if (cancelAnimationFrame(e), !u.current) return;
          o(!1);
          return;
        }
        e = requestAnimationFrame(t);
      }
      e = requestAnimationFrame(t);
    }
  }) : null;
}
export { b as FocusSentinel };